import React from 'react';
import RegisterCompleteView from '../Views/TO/Register/RegisterCompleteView';

class RegisterComplete extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
        };
    }

    render() {
        return (
            <RegisterCompleteView
                email={this.props.email}
                style={this.props.style}
            />
        );
    }
}

export default RegisterComplete;